<template>
  <div class="container text-center mt-5 mb-5">
    <h1>{{ $t(LangConstants.forbidden_page_text) }}..</h1>
  </div>
</template>

<script>
/**
 * Forbidden 403 - Page
 */
import Constants from "../../constants/index";
export default {
  name: "404",

  computed: {
    LangConstants() {
      return Constants;
    },
  },
};
</script>
